<template>
  <div class="parent">
    <l-map
      ref="peta"
      class="map"
      :zoom="map.zoom"
      :center.sync="map.center"
      :options="mapOptions"
    >
      <l-control
        position="bottomleft"
        v-show="loading"
        style="margin-left: -10px; margin-bottom: 0px"
      >
        <vs-button
          style="
            width: 100%;
            font-weight: 600;
            cursor: pointer;
            color: black;
            font-size: 18px;
          "
          color="light"
        >
          {{ desc_load }}</vs-button
        >
      </l-control>
      <l-control position="topright">
        <b-row>
          <b-col cols="2">&nbsp;</b-col>

          <!-- <b-col cols="2" class="d-flex align-items-center">
            <vs-dropdown vs-custom-content>
              <div class="filter-status-btn d-flex align-items-center p-3">
                <feather-icon icon="FilterIcon" />
              </div>
              <vs-dropdown-menu>
                <div class="list-group">
                  <b-list-group flush>
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>All (<span class="num"> 65 </span>)</span>
                      <vs-checkbox v-model="checkAll"></vs-checkbox>
                    </b-list-group-item>

                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Moving (<span class="num"> 50 </span>)</span>
                      <vs-checkbox v-model="checkMoving"></vs-checkbox>
                    </b-list-group-item>

                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Parking (<span class="num"> 5 </span>)</span>
                      <vs-checkbox v-model="checkParking"></vs-checkbox>
                    </b-list-group-item>

                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Stop (<span class="num"> 10 </span>)</span>
                      <vs-checkbox v-model="checkStop"></vs-checkbox>
                    </b-list-group-item>

                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>No Data (<span class="num"> 0 </span>)</span>
                      <vs-checkbox v-model="checkNoData"></vs-checkbox>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </vs-dropdown-menu>
            </vs-dropdown>
          </b-col> -->

          <b-col cols="10">
            <div class="fs-search-input d-flex d-inline-block">
              <vs-icon icon="search" size="small" class="mr-1"></vs-icon>
              <input
                style="font-size: 18px"
                type="text"
                placeholder="Search and Press Enter"
                v-model="keyword"
                @keyup="search_vehicle"
              />
            </div>
          </b-col>
        </b-row>
      </l-control>

      <l-control-polyline-measure
        :options="{ showUnitControl: false }"
        position="topleft"
      />

      <l-control-layers position="bottomleft"></l-control-layers>

      <l-control position="bottomleft" style="width: 100%; margin-right: 4%">
        <vs-button
          @click="showPolygone('speed_zone')"
          type="filled"
          :color="show_hide_color.speed_zone"
          title="Show Speed Limit by Zone"
          class="btn_poi"
          ><img
            src="@/assets/images/file-icons/speed_zone.svg"
            alt=""
            width="18"
            :style="
              show_hide.speed_zone
                ? 'filter: invert(100%)'
                : 'filter: invert(0%)'
            "
        /></vs-button>
      </l-control>
      <l-control position="bottomleft" style="width: 100%; margin-right: 4%">
        <vs-button
          @click="showPolygone('geofence')"
          type="filled"
          :color="show_hide_color.geofence"
          title="Show Geofence"
          class="btn_poi"
          ><img
            src="@/assets/images/file-icons/geofence.svg"
            alt=""
            width="18"
            :style="
              show_hide.geofence ? 'filter: invert(100%)' : 'filter: invert(0%)'
            "
        /></vs-button>
      </l-control>

      <l-control position="bottomleft" style="width: 100%; margin-right: 4%">
        <vs-button
          @click="showPolygone('poi')"
          type="filled"
          :color="show_hide_color.poi"
          :title="'One Click to show All POI \nDouble Click to show All POI Name'"
          class="btn_poi"
        >
          <img
            src="@/assets/images/file-icons/poi.svg"
            alt=""
            width="18"
            :style="
              show_hide.poi ? 'filter: invert(100%)' : 'filter: invert(0%)'
            "
          />
        </vs-button>
      </l-control>

      <l-control-fullscreen
        position="bottomright"
        :options="{
          title: { false: 'Fullscreen', true: 'RegularScreen' }
        }"
      />

      <l-control-zoom
        position="bottomright"
        class="zoom-control"
      ></l-control-zoom>

      <template>
        <l-control position="topright" class="d-flex">
          <div class="switch p-3" style="font-family: 'Poppins', sans-serif">
            <vs-switch
              v-model="showLabel"
              color="#28C76F"
              class="switch-button"
              name="switch-button"
            />
            <span>Vehicle Name</span>
          </div>
        </l-control>
      </template>

      <l-tile-layer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
        :options="{ maxZoom: 22 }"
      />

      <l-polygon
        v-for="(item, index) in zone_speed.polygon"
        :key="'A' + index"
        :lat-lngs="item.latlngs"
        :color="item.color"
        :fillColor="item.color"
        :visible="show_hide.speed_zone == true"
      >
        <l-popup>
          <div class="leaflet-popup-header">Speed By Zone</div>
          <table class="leaflet-popup-table">
            <tr>
              <td>Zone Name</td>
              <td>{{ item.name }}</td>
            </tr>
            <tr>
              <td>Speed Limit</td>
              <td>{{ item.speed }} Km/h</td>
            </tr>
          </table>
        </l-popup>
      </l-polygon>

      <l-polygon
        v-for="(item, index) in geofence.polygon_in"
        :key="'IN' + index"
        :lat-lngs="item.latlngs"
        :color="item.color"
        :fillColor="item.color"
        :visible="show_hide.geofence == true"
      >
        <l-popup>
          <div class="leaflet-popup-header">Geofence Zone</div>
          <table class="leaflet-popup-table">
            <tr>
              <td>Geofence Name</td>
              <td>{{ item.name }}</td>
            </tr>
            <tr>
              <td>Geofence Type</td>
              <td>{{ item.type }}</td>
            </tr>
          </table>
        </l-popup>
      </l-polygon>

      <l-polygon
        v-for="(item, index) in geofence.polygon_out"
        :key="'OUT' + index"
        :lat-lngs="item.latlngs"
        :color="item.color"
        :fillColor="item.color"
        :visible="show_hide.geofence == true"
      >
        <l-popup>
          <div class="leaflet-popup-header">Geofence Zone</div>
          <table class="leaflet-popup-table">
            <tr>
              <td>Geofence Name</td>
              <td>{{ item.name }}</td>
            </tr>
            <tr>
              <td>Geofence Type</td>
              <td>{{ item.type }}</td>
            </tr>
          </table>
        </l-popup>
      </l-polygon>

      <!-- =============== START POI POLYGONE ================= -->

      <l-layer-group :visible="isPermanentPoi">
        <l-polygon
          v-for="item in poi.polygon"
          :key="item.id"
          :lat-lngs="item.latlngs"
          :visible="show_hide.poi == true"
        >
          <l-tooltip
            :options="{
              interactive: true,
              permanent: true,
              direction: 'top',
              className: 'leaflet-tooltip'
            }"
            >POI : {{ item.name }}</l-tooltip
          >
          <!-- <l-popup>
                  <div class="leaflet-popup-header">Point of Interest</div>
                  <table class="leaflet-popup-table">
                    <tr>
                      <td>POI Name</td>
                      <td>{{ item.name }}</td>
                    </tr>
                  </table>
                </l-popup> -->
        </l-polygon>
      </l-layer-group>

      <l-layer-group :visible="!isPermanentPoi">
        <l-polygon
          v-for="item in poi.polygon"
          :key="item.id"
          :lat-lngs="item.latlngs"
          :visible="show_hide.poi == true"
        >
          <l-tooltip
            :options="{
              interactive: true,
              permanent: false,
              direction: 'top',
              className: 'leaflet-tooltip'
            }"
            >POI : {{ item.name }}</l-tooltip
          >
        </l-polygon>
      </l-layer-group>

      <!-- =============== END POI POLYGONE ================= -->

      <!-- =============== START POI MARKER ================= -->

      <l-layer-group :visible="isPermanentPoi">
        <l-marker
          v-for="item in poi.marker"
          :key="item.id"
          :lat-lng="item.latlngs"
          :icon="item.icon"
          :visible="show_hide.poi == true"
        >
          <l-tooltip
            :options="{
              interactive: true,
              permanent: true,
              direction: 'top',
              className: 'leaflet-tooltip'
            }"
            >POI : {{ item.name }}</l-tooltip
          >
        </l-marker>
      </l-layer-group>

      <l-layer-group :visible="!isPermanentPoi">
        <l-marker
          v-for="item in poi.marker"
          :key="item.id"
          :lat-lng="item.latlngs"
          :icon="item.icon"
          :visible="show_hide.poi == true"
        >
          <l-tooltip
            :options="{
              interactive: true,
              permanent: false,
              direction: 'top',
              className: 'leaflet-tooltip'
            }"
            >POI : {{ item.name }}</l-tooltip
          >
        </l-marker>
      </l-layer-group>

      <!-- =============== END POI MARKER ================= -->

      <!-- <v-marker-cluster> -->
      <l-layer-group :visible="isPermanent">
        <l-rotated-marker
          v-for="(item, index) in markers"
          :key="`${index}_${item.id}`"
          :lat-lng="item.position"
          :icon="item.icon"
          :rotationAngle="item.angle"
          :visible="item.visible"
        >
          <l-tooltip
            :options="{
              permanent: true,
              interactive: true,
              direction: 'right',
              className: 'leaflet-tooltip'
            }"
            >{{ item.deviceName }}</l-tooltip
          >

          <l-popup :options="{}">
            <div class="leaflet-popup-header">Device Detail</div>
            <table class="leaflet-popup-table">
              <tr>
                <td>License Plate</td>
                <td>{{ item.plate }}</td>
              </tr>
              <tr v-if="actor.privilege <= 4">
                <td>GSM Number</td>
                <td>{{ item.gsm }}</td>
              </tr>
              <tr>
                <td>ACC</td>
                <td>{{ item.acc }}</td>
              </tr>
              <tr>
                <td>Speed</td>
                <td>{{ item.speed }}</td>
              </tr>
              <tr>
                <td>Temperature</td>
                <td>
                  {{
                    item.temperature == null || item.temperature == 'NULL'
                      ? `N/A`
                      : `${item.temperature}&deg;C`
                  }}
                </td>
              </tr>
              <tr>
                <td>Door</td>
                <td>
                  {{
                    item.door == null || item.door == 'NULL'
                      ? 'N/A'
                      : item.door == 1
                      ? `Open`
                      : 'Close'
                  }}
                </td>
              </tr>
              <tr>
                <td>Alarm</td>
                <td>
                  {{ item.alarm }}
                </td>
              </tr>
              <tr>
                <td>Battery</td>
                <td>
                  <img
                    style="width: 30px"
                    :src="`https://img.gps.id/assets/battery/${item.battery}.png`"
                  />
                </td>
              </tr>
              <tr>
                <td>Mileage</td>
                <td>
                  {{
                    (parseInt(item.mileage) / 1000)
                      .toFixed(2)
                      .toString()
                      .replace('.', ',')
                      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  Km
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td v-if="showAddress">{{ item.address }}</td>
                <td v-else>
                  <a
                    href="javascript:;"
                    @click="
                      getAddress(
                        {
                          lat: item.latLon.split(', ')[1],
                          lon: item.latLon.split(', ')[0]
                        },
                        'markers',
                        index
                      )
                    "
                    >Show</a
                  >
                </td>
              </tr>
              <tr>
                <td style="width: 48%">Expired GSM</td>
                <td
                  :style="
                    new Date(item.expired_gsm) < new Date() ? `color:red` : ``
                  "
                >
                  {{
                    `${item.expired_gsm} ${
                      new Date() > new Date(item.expired_gsm) ? '(Expired)' : ''
                    }`
                  }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>{{ item.latLon.split(', ')[0] }}</td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>{{ item.latLon.split(', ')[1] }}</td>
              </tr>
              <tr>
                <td>Lifetime Warranty</td>
                <td :style="item.lifetime_warranty === 0 ? `color:red` : ``">
                  {{
                    item.lifetime_warranty === 1
                      ? 'Active'
                      : item.lifetime_warranty === 0
                      ? 'Not Active'
                      : 'Not Available'
                  }}
                </td>
              </tr>
              <tr>
                <td>Last Positioning</td>
                <td>{{ item.time }}</td>
              </tr>
              <tr>
                <td>Last Update</td>
                <td>{{ item.serverTime }}</td>
              </tr>
            </table>

            <div class="leaflet-popup-footer">&nbsp;</div>
          </l-popup>
        </l-rotated-marker>
      </l-layer-group>

      <l-layer-group :visible="!isPermanent">
        <l-rotated-marker
          v-for="(item, index) in markers"
          :key="`${index}_${item.id}`"
          :lat-lng="item.position"
          :icon="item.icon"
          :rotationAngle="item.angle"
          :visible="item.visible"
        >
          <l-tooltip
            :options="{
              permanent: false,
              interactive: true,
              direction: 'right',
              className: 'leaflet-tooltip'
            }"
            >{{ item.deviceName }}</l-tooltip
          >

          <l-popup :options="{}">
            <div class="leaflet-popup-header">Device Detail</div>
            <table class="leaflet-popup-table">
              <tr>
                <td>License Plate</td>
                <td>{{ item.plate }}</td>
              </tr>
              <tr v-if="actor.privilege <= 4">
                <td>GSM Number</td>
                <td>{{ item.gsm }}</td>
              </tr>
              <tr>
                <td>ACC</td>
                <td>{{ item.acc }}</td>
              </tr>
              <tr>
                <td>Speed</td>
                <td>{{ item.speed }}</td>
              </tr>
              <tr>
                <td>Temperature</td>
                <td>
                  {{
                    item.temperature == null || item.temperature == 'NULL'
                      ? `N/A`
                      : `${item.temperature}&deg;C`
                  }}
                </td>
              </tr>
              <tr>
                <td>Door</td>
                <td>
                  {{
                    item.door == null || item.door == 'NULL'
                      ? 'N/A'
                      : item.door == 1
                      ? `Open`
                      : 'Close'
                  }}
                </td>
              </tr>
              <tr>
                <td>Alarm</td>
                <td>
                  {{ item.alarm }}
                </td>
              </tr>
              <tr>
                <td>Battery</td>
                <td>
                  <img
                    style="width: 30px"
                    :src="`https://img.gps.id/assets/battery/${item.battery}.png`"
                  />
                </td>
              </tr>
              <tr>
                <td>Mileage</td>
                <td>
                  {{
                    (parseInt(item.mileage) / 1000)
                      .toFixed(2)
                      .toString()
                      .replace('.', ',')
                      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  Km
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td v-if="showAddress">{{ item.address }}</td>
                <td v-else>
                  <a
                    href="javascript:;"
                    @click="
                      getAddress(
                        {
                          lat: item.latLon.split(', ')[1],
                          lon: item.latLon.split(', ')[0]
                        },
                        'markers',
                        index
                      )
                    "
                    >Show</a
                  >
                </td>
              </tr>
              <tr>
                <td style="width: 48%">Expired GSM</td>
                <td
                  :style="
                    new Date(item.expired_gsm) < new Date() ? `color:red` : ``
                  "
                >
                  {{
                    `${item.expired_gsm} ${
                      new Date() > new Date(item.expired_gsm) ? '(Expired)' : ''
                    }`
                  }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>{{ item.latLon.split(', ')[0] }}</td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>{{ item.latLon.split(', ')[1] }}</td>
              </tr>
              <tr>
                <td>Lifetime Warranty</td>
                <td :style="item.lifetime_warranty === 0 ? `color:red` : ``">
                  {{
                    item.lifetime_warranty === 1
                      ? 'Active'
                      : item.lifetime_warranty === 0
                      ? 'Not Active'
                      : 'Not Available'
                  }}
                </td>
              </tr>
              <tr>
                <td>Last Positioning</td>
                <td>{{ item.time }}</td>
              </tr>
              <tr>
                <td>Last Update</td>
                <td>{{ item.serverTime }}</td>
              </tr>
            </table>

            <div class="leaflet-popup-footer">&nbsp;</div>
          </l-popup>
        </l-rotated-marker>
      </l-layer-group>
      <!-- </v-marker-cluster> -->
    </l-map>
  </div>
</template>

<style>
.leaflet-tooltip {
  position: absolute;
  margin: 5px;
  background-color: #1da1f2 !important;
  border: 1px solid white;
  border-radius: 8px 8px;
  color: white;
  font-size: 12.5px;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.map .switch {
  margin-inline: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.map .switch span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
}

.map .switch .switch-button {
  border-radius: 25px;
}

.btn_poi {
  z-index: 1000;
  border: 0.16em solid rgb(169, 169, 169);
  border-radius: 0.4em;
  margin-right: 0.1em;
  width: 48px;
  height: 48px;
  padding: 0px !important;
}

.btn_poi img {
  margin-top: 0px;
  margin-left: 0px;
}
</style>

<script>
import {
  LMap,
  LTileLayer,
  LCircle,
  LMarker,
  LControl,
  LPopup,
  LIcon,
  LTooltip,
  LControlLayers,
  LControlZoom,
  LPolygon,
  LLayerGroup
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BListGroup,
  BListGroupItem,
  BFormRadio,
  BBadge,
  BFormCheckbox,
  BProgress,
  BModal,
  VBModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import { Icon } from 'leaflet'

import LRotatedMarker from 'vue2-leaflet-rotatedmarker'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import LControlFullscreen from 'vue2-leaflet-fullscreen'

import '@/assets/markerCluster/MarkerCluster.css'
import '@/assets/markerCluster/MarkerCluster.Default.css'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LMarker,
    LControl,
    LPopup,
    LIcon,
    LTooltip,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormDatepicker,
    BListGroup,
    BListGroupItem,
    BFormRadio,
    BBadge,
    BFormCheckbox,
    BProgress,
    BModal,
    vSelect,
    flatPickr,
    // apexcharts: VueApexCharts
    VueApexCharts,
    LRotatedMarker,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LControlPolylineMeasure,
    LControlLayers,
    LControlFullscreen,
    LControlZoom,
    LPolygon,
    LLayerGroup
  },

  directives: {
    'b-modal': VBModal,
    Ripple
  },

  data() {
    return {
      active: false,
      url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
      tileProviders: [
        {
          name: 'Google Street',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.1779895, 106.8128504), //-1.041276, 122.288486
        zoom: 12
      },
      mapOptions: {
        // zoomSnap: 0.5
        zoomControl: false
      },

      showPopup: false,

      checkAll: true,
      checkMoving: false,
      checkParking: false,
      checkStop: false,
      checkNoData: false,

      allVehicle: [],
      markers: [],
      total_vehicle: 0,
      showAddress: false,
      ws: '',
      isConnect: 'open',
      allVehicle: [],
      last_vehicle: '',
      last_map_position: [],
      keyword: '',
      vehicle_all: 0,
      vehicle_moving: 0,
      vehicle_parking: 0,
      vehicle_stop: 0,
      vehicle_no_data: 0,
      loading: false,
      desc_load: 'Data in progress...',

      show_hide: {
        poi: false,
        geofence: false,
        speed_zone: false
      },

      show_hide_color: {
        poi: 'white',
        geofence: 'white',
        speed_zone: 'white'
      },

      poi: {
        marker: [],
        polygon: []
      },

      zone_speed: {
        polygon: []
      },

      geofence: {
        polygon_in: [],
        polygon_out: []
      },

      showLabel: false,
      isPermanent: false,

      dataSocket: [],
      isPermanentPoi: false,
      clicks: 0
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data

        if (this.actor.privilege >= 4) {
          this.getPoiList()
          this.getZoneSpeedList()
          this.getGeofenceZone()
        }
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    window.addEventListener('beforeunload', () => {
      if (this.ws) {
        this.ws.send('REMOVE_CLIENT')
        this.ws.close()
      }
    })
  },

  computed: {
    show_label() {
      return this.showLabel
    }
  },

  watch: {
    show_label(val) {
      if (val) this.isPermanent = true
      else this.isPermanent = false
    }
  },

  mounted() {
    this.getImeiList()
    // this.connect()
    setInterval(() => {
      this.getDataInterval()
    }, 60000)
  },

  beforeDestroy() {
    if (this.ws) {
      this.ws.send('REMOVE_CLIENT')
      this.ws.close()
    }
  },

  methods: {
    showInfo() {
      this.showPopup = !this.showPopup
    },
    getImeiList() {
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/gps/list_monitoring`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          let data = res.data.message.data

          if (data.length > 0) {
            data.map((item) => {
              const x = {
                visible: true,
                imei: item.id,
                plate: item.plate,
                deviceName: item.device_name,
                position: L.latLng(item.latitude, item.longitude),
                angle: item.angle,

                acc: item.acc === 1 ? 'ON' : 'OFF',
                gsm: item.gsm_no,
                latLon: `${parseFloat(item.longitude)}, ${parseFloat(
                  item.latitude
                )}`,
                alarm: item.ref_alert ? item.ref_alert.description : 'None',
                speed: `${item.speed} Km/H`,
                mileage: item.mileage,
                time: item.time,
                door: item.door,
                temperature: item.temperature,
                serverTime: item.server_time,
                address:
                  item.longitude == 0 && item.latitude == 0
                    ? 'Belum ada Data'
                    : item.address,
                gps_type: item.gps_type,
                ref_icon: item.fullpath_icon,
                expired_gsm: item.expired_gsm,
                lifetime_warranty: item.lifetime_warranty
              }

              let battery
              if (parseInt(item.battery) > 80) battery = '6'
              else if (parseInt(item.battery) > 60) battery = '5'
              else if (parseInt(item.battery) > 40) battery = '4'
              else if (parseInt(item.battery) > 20) battery = '3'
              else if (parseInt(item.battery) > 5) battery = '2'
              else if (parseInt(item.battery) >= 0) battery = '1'
              else battery = '-1'

              x.battery = battery

              let type = ''

              if (item.is_expired) type = 'alarm'
              else {
                if (
                  Date.now() - new Date(item.server_time).getTime() >=
                  86400000
                ) {
                  type = 'lost'
                } else {
                  if (item.alert != 0) type = 'alarm'
                  else {
                    if (
                      item.acc === 1 ||
                      (item.speed > 3 &&
                        Date.now() - new Date(item.time).getTime() <= 600000)
                    ) {
                      type = 'acc_on'
                    } else type = 'parking'
                  }
                }
              }

              x.type = type

              if (item.icon)
                x.icon = L.icon({
                  iconUrl: `${item.fullpath_icon[type]}`,
                  iconSize: [32, 32]
                })
              else x.icon = L.icon.Default

              this.markers.push(x)

              if (item.latitude != 0 && item.longitude != 0) {
                this.last_map_position = [
                  {
                    imei: item.id,
                    lat: item.latitude,
                    lon: item.longitude
                  }
                ]

                this.last_vehicle =
                  this.last_map_position[this.last_map_position.length - 1].imei
              }

              if (!item.is_expired)
                this.allVehicle.push(`${item.port}:${item.id}`)
            })

            this.map.center = L.latLng(
              this.last_map_position[this.last_map_position.length - 1].lat,
              this.last_map_position[this.last_map_position.length - 1].lon
            )
            this.map.zoom = 8
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getDataInterval() {
      this.loading = true
      this.desc_load = 'Update data location...'
      this.$http
        .get(`${this.$api.endpoint}/gps/list_monitoring`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          let tempData = res.data.message.data

          if (tempData.length > 0) {
            this.markers.map((data, i) => {
              const index = tempData.map((e) => e.id).indexOf(data.imei)

              if (index > -1) {
                this.showAddress = false

                let battery
                if (parseInt(tempData[index].battery) > 80) battery = '6'
                else if (parseInt(tempData[index].battery) > 60) battery = '5'
                else if (parseInt(tempData[index].battery) > 40) battery = '4'
                else if (parseInt(tempData[index].battery) > 20) battery = '3'
                else if (parseInt(tempData[index].battery) > 5) battery = '2'
                else if (parseInt(tempData[index].battery) >= 0) battery = '1'
                else battery = '-1'

                let type = 'parking'
                let time = tempData[index].time
                if (Date.now() - new Date(time).getTime() >= 86400000) {
                  type = 'lost'
                } else {
                  if (parseInt(tempData[index].alert) != 0) type = 'alarm'
                  else {
                    if (
                      parseInt(tempData[index].acc) === 1 ||
                      (parseInt(tempData[index].speed) > 3 &&
                        Date.now() - new Date(time).getTime() <= 600000)
                    ) {
                      type = 'acc_on'
                    } else type = 'parking'
                  }
                }

                if (this.markers[i].ref_icon) {
                  this.markers[i].icon = L.icon({
                    iconUrl: `${this.markers[i].ref_icon[type]}`,
                    iconSize: [32, 32]
                  })
                }

                this.markers[i].position = L.latLng(
                  tempData[index].latitude,
                  tempData[index].longitude
                )

                this.markers[i].angle = tempData[index].angle
                this.markers[i].acc = tempData[index].acc === 1 ? 'ON' : 'OFF'
                this.markers[i].latLon = `${parseFloat(
                  tempData[index].longitude
                )}, ${parseFloat(tempData[index].latitude)}`
                this.markers[i].speed = `${tempData[index].speed} Km/H`
                this.markers[i].door = tempData[index].door
                this.markers[i].temperature = tempData[index].temperature
                this.markers[i].mileage = tempData[index].mileage
                this.markers[i].battery = battery
                this.markers[i].time = tempData[index].time
                this.markers[i].serverTime = tempData[index].server_time
                this.markers[i].alarm = tempData[index].ref_alert
                  ? tempData[index].ref_alert.description
                  : 'None'
              }
            })
          }

          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getAddress(latlng, target, index = 0) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: latlng.lat,
            longitude: latlng.lon
          }
        })
        .then((res) => {
          this[target][index].address = res.data.message
          this.showAddress = true
        })
    },

    // connect() {
    //   this.ws = new WebSocket(`${this.$api.new_socket}`)
    //   if (this.ws) {
    //     this.ws.onopen = (e) => {
    //       if (this.allVehicle.length > 0) {
    //         this.ws.send('NEW_CLIENT=' + this.allVehicle.join(','))

    //         this.isConnect = 'close'
    //         if (this.ws.send) {
    //           this.isConnect = 'open'
    //           console.log('Socket is open...')
    //         }
    //       }
    //     }
    //   }

    //   this.ws.onmessage = (msg) => {
    //     const data = JSON.parse(msg.data)

    //     if (data.imei == this.last_map_position[0].imei)
    //       this.proses_update_socket(data)
    //   }

    //   this.ws.onclose = (e) => {
    //     this.isConnect = 'close'

    //     if (this.$route.name == 'monitoring') {
    //       if (this.isConnect == 'close') {
    //         setTimeout(() => {
    //           this.connect()
    //         }, 10000)
    //       }

    //       console.log(
    //         'Socket is closed. Reconnect will be attempted in 10 second.'
    //       )
    //     }
    //   }

    //   this.ws.onerror = (err) => {
    //     this.isConnect = 'close'
    //     console.error('Socket encountered error: ', 'Closing socket')
    //     this.ws.close()
    //   }
    // },

    // proses_update_socket(data) {
    //   let type = 'parking'
    //   let time = this.secondToDateTime(parseInt(data.time))
    //   if (Date.now() - new Date(time).getTime() >= 86400000) {
    //     type = 'lost'
    //   } else {
    //     if (parseInt(data.alarm) != 0) type = 'alarm'
    //     else {
    //       if (
    //         parseInt(data.acc) === 1 ||
    //         (parseInt(data.speed) > 3 &&
    //           Date.now() - new Date(time).getTime() <= 600000)
    //       ) {
    //         type = 'acc_on'
    //       } else type = 'parking'
    //     }
    //   }
    //   const i = this.markers.findIndex((item) => item.imei == data.imei)
    //   if (i > -1) {
    //     if (data.type === 'location') {
    //       this.showAddress = false
    //       let battery
    //       if (parseInt(data.voltage) > 80) battery = '6'
    //       else if (parseInt(data.voltage) > 60) battery = '5'
    //       else if (parseInt(data.voltage) > 40) battery = '4'
    //       else if (parseInt(data.voltage) > 20) battery = '3'
    //       else if (parseInt(data.voltage) > 5) battery = '2'
    //       else if (parseInt(data.voltage) >= 0) battery = '1'
    //       else battery = '-1'
    //       if (this.markers[i].ref_icon) {
    //         this.markers[i].icon = L.icon({
    //           iconUrl: `${this.markers[i].ref_icon[type]}`,
    //           iconSize: [32, 32]
    //         })
    //       }
    //       this.markers[i].position = L.latLng(data.latitude, data.longitude)
    //       this.markers[i].angle = parseInt(data.angle)
    //       this.markers[i].acc = parseInt(data.acc) === 0 ? 'OFF' : 'ON'
    //       this.markers[i].latLon = `${data.longitude}, ${data.latitude}`
    //       this.markers[i].speed = `${data.speed} Km/H`
    //       this.markers[i].door = data.door
    //       this.markers[i].temperature =
    //         data.temperature != 'NULL' ? data.temperature : null
    //       this.markers[i].mileage = data.mileage
    //       this.markers[i].battery = battery
    //       this.markers[i].time = this.secondToDateTime(data.time)
    //       this.markers[i].serverTime = this.secondToDateTime(data.time)
    //       this.markers[i].alarm =
    //         parseInt(data.alarm) == 0
    //           ? '-'
    //           : this.list_alarm.find((e) => e.value === parseInt(data.alarm))
    //               .label
    //     } else if (data.type === 'heartbeat') {
    //       let battery
    //       if (parseInt(data.voltage) > 80) battery = '6'
    //       else if (parseInt(data.voltage) > 60) battery = '5'
    //       else if (parseInt(data.voltage) > 40) battery = '4'
    //       else if (parseInt(data.voltage) > 20) battery = '3'
    //       else if (parseInt(data.voltage) > 5) battery = '2'
    //       else if (parseInt(data.voltage) >= 0) battery = '1'
    //       else battery = '-1'
    //       this.markers[i].serverTime = this.secondToDateTime(data.time)
    //       this.markers[i].acc = data.acc == 1 ? 'ON' : 'OFF'
    //       this.markers[i].battery = battery
    //       this.markers[i].door = data.door
    //       this.markers[i].temperature = data.temperature
    //       if (this.markers[i].ref_icon) {
    //         this.markers[i].icon = L.icon({
    //           iconUrl: `${this.markers[i].ref_icon[type]}`,
    //           iconSize: [32, 32]
    //         })
    //       }
    //     }
    //   }
    // },

    search_vehicle(e) {
      if (e.keyCode === 13) {
        this.desc_load = 'Searching vehicle...'
        this.loading = true

        console.log(this.keyword.toLowerCase())

        const i = this.markers.findIndex(
          (item) => item.plate.toLowerCase() === this.keyword.toLowerCase()
        )

        console.log(i)

        if (i > -1) {
          setTimeout(() => {
            this.last_map_position = [
              {
                imei: this.markers[i].imei,
                lat: this.markers[i].latLon.split(', ')[1],
                lon: this.markers[i].latLon.split(', ')[0]
              }
            ]

            this.centerMap({
              lat: this.markers[i].latLon.split(', ')[1],
              lon: this.markers[i].latLon.split(', ')[0]
            })

            this.loading = false
          }, 2000)
        } else {
          const i2 = this.markers.findIndex(
            (item) =>
              item.deviceName.toLowerCase() === this.keyword.toLowerCase()
          )

          if (i2 > -1) {
            setTimeout(() => {
              this.last_map_position = [
                {
                  imei: this.markers[i2].imei,
                  lat: this.markers[i2].latLon.split(', ')[1],
                  lon: this.markers[i2].latLon.split(', ')[0]
                }
              ]

              this.centerMap({
                lat: this.markers[i].latLon.split(', ')[1],
                lon: this.markers[i].latLon.split(', ')[0]
              })

              this.loading = false
            }, 2000)
          } else {
            this.desc_load = 'Vehicle Not Found'
          }
        }
      }
    },

    secondToDateTime(second) {
      let d = new Date(parseInt(second) * 1000)
      return d.toISOString().replace('T', ' ').replace('.000Z', '')
    },

    centerMap(item) {
      const newZoom = 18
      this.$refs.peta.mapObject.setView(L.latLng(item.lat, item.lon), newZoom)
    },

    showPolygone(params) {
      if (params === 'poi') {
        this.clicks++
        if (this.clicks === 1) {
          this.timer = setTimeout(() => {
            this.show_hide[params] = !this.show_hide[params]
            this.isPermanentPoi = false
            this.clicks = 0

            if (this.show_hide[params] == true)
              this.show_hide_color[params] = 'primary'
            else this.show_hide_color[params] = 'white'
          }, 700)
        } else {
          clearTimeout(this.timer)
          this.show_hide[params] = !this.show_hide[params]
          this.isPermanentPoi = true
          this.clicks = 0

          if (this.show_hide[params] == true)
            this.show_hide_color[params] = 'primary'
          else this.show_hide_color[params] = 'white'
        }
      } else {
        this.show_hide[params] = !this.show_hide[params]
        if (this.show_hide[params] == true)
          this.show_hide_color[params] = 'primary'
        else this.show_hide_color[params] = 'white'
      }
    },

    getPoiList() {
      this.poi.marker = []
      this.poi.polygon = []

      this.$http
        .get(`${this.$api.endpoint}/poi/general`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          data.map((item, index) => {
            let target = item.type === 0 ? 'marker' : 'polygon'
            let latlngs =
              item.type === 0
                ? L.latLng(item.lat, item.lon)
                : this.geomToPolygon(item.geom)

            this.poi[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              icon: item.icon
                ? L.icon({
                    iconUrl: `${
                      item.icon.fullpath_icon
                        ? item.icon.fullpath_icon
                        : item.icon.icon
                    }`,
                    iconSize: [30, 30]
                  })
                : L.icon.Default
            })
          })
        })
        .catch((error) => {})
    },

    getZoneSpeedList() {
      this.$http
        .get(`${this.$api.endpoint}/speed_limit_by_zone/all_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          data.map((item, index) => {
            let target = 'polygon'
            let latlngs = this.geomToPolygon(item.geom)

            this.zone_speed[target].push({
              id: item.id,
              name: item.name,
              speed: item.speed,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: '#B8860B'
            })
          })
        })
        .catch((error) => {})
    },

    getGeofenceZone() {
      this.$http
        .get(`${this.$api.endpoint}/zone/geofence_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          data.map((item, index) => {
            let target = item.type == 0 ? 'polygon_in' : 'polygon_out'
            let latlngs = this.geomToPolygon(item.geom)

            this.geofence[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: item.type == 0 ? 'red' : 'green',
              type: item.type == 0 ? 'IN' : 'OUT'
            })
          })
        })
        .catch((error) => {})
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.parent {
  font-family: 'Poppins', sans-serif;
}

.vue2leaflet-map {
  &.leaflet-container {
    height: 100vh;
  }
}

.filter-status-btn {
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
  color: #fff;
}

.list-group {
  width: 200px;
}

.list-group span.num {
  color: #1da1f2;
  font-weight: 600;
}

.fs-search-input {
  background-color: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 16px rgba(165, 163, 174, 0.45);
  border-radius: 12px;
  padding: 1.5em 10em 1.5em 1.5em;
}

.fs-search-input input {
  border: none;
  background-color: transparent;
}
</style>
